import React from 'react';
import {StyledEuroInput} from './StyledEuroInput';
import {EuroIcon} from '../../icons';

const EuroInput = ({
  ...rest
}) => {
  return (
    <StyledEuroInput
      addonBefore={<EuroIcon />}
      min={0.1}
      size='large'
      step={0.01}
      type='number'
      {...rest}
    />
  )
}

export default EuroInput;
